$.fn.filterGroups = function (options) {
  let parentSelect = $(options.groupSelector);

  function updateDependentSelect(mainSelect, selectToUpdate) {
    let optGroupLabel = $(mainSelect).val();
    let optGroup = selectToUpdate.data('original-groups').filter(`optgroup[label="${optGroupLabel}"]`)[0];
    let optChildren = $(optGroup).html();
    if (selectToUpdate.data('with-all')) {
      optChildren = `<option value=' '>${I18n.t('js.all')}</option>` + optChildren;
    }
    selectToUpdate.html(optChildren);
    selectToUpdate.trigger('chosen:updated');
  }

  return this.each(function () {
    let dependentSelect = $(this);

    // Clone the optgroups to data, then remove them from dom
    let originalGruops = dependentSelect.find('optgroup').clone();
    dependentSelect.data('original-groups', originalGruops);
    dependentSelect.children('optgroup').remove();
    dependentSelect.trigger('chosen:updated');
    updateDependentSelect(parentSelect, dependentSelect);

    $(parentSelect).on('change', function () {
      updateDependentSelect(this, dependentSelect);
    });
  });
};



// WEBPACK FOOTER //
// ./app/webpacker/src/js/modules/optgroup_filter.js